var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-badge")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": !_vm.isLabelUnique,
                          label: _vm.$ct("unique-label"),
                        },
                        model: {
                          value: _vm.label,
                          callback: function ($$v) {
                            _vm.label = $$v
                          },
                          expression: "label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: _vm.pinCode !== null,
                          label: _vm.$ct("change-pincode"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setChangePincode($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-transition-slide-height",
                    [
                      _vm.pinCode !== null
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-nfc-pin-code-input", {
                                attrs: {
                                  "has-error":
                                    !_vm.pinCodeIsValid && _vm.pinCodeBlured,
                                  label: _vm.$ct("pin-code-optional"),
                                },
                                on: {
                                  blur: function ($event) {
                                    _vm.pinCodeBlured = true
                                  },
                                },
                                model: {
                                  value: _vm.pinCode,
                                  callback: function ($$v) {
                                    _vm.pinCode = $$v
                                  },
                                  expression: "pinCode",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.isSaving, icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    disabled: _vm.isSaving || !_vm.valid,
                    icon: "check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }